/* NutriLife theme scripts */
(function () {
  'use strict';

  /* ---------- Mobile nav ---------- */
  function initNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('[data-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', nav.classList.contains('is-open'));
    });
    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { nav.classList.remove('is-open'); });
    });
  }

  /* ---------- Header search bar (inline, no page jump to type) ---------- */
  function initSearch() {
    var bar = document.querySelector('[data-search-bar]');
    if (!bar) return;
    var input = bar.querySelector('[data-search-input]');
    document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isHidden = bar.hasAttribute('hidden');
        if (isHidden) {
          bar.removeAttribute('hidden');
          if (input) input.focus();
        } else {
          bar.setAttribute('hidden', '');
        }
        document.querySelectorAll('[data-search-toggle]').forEach(function (b) {
          b.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
        });
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !bar.hasAttribute('hidden')) { bar.setAttribute('hidden', ''); }
    });
  }

  /* ---------- Header scroll shadow ---------- */
  function initHeaderScroll() {
    var header = document.querySelector('.header');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var selectors = '.section-head, .feature, .product-card, .testimonial, .quiz-promo, .contact-cta__box, .about__media, .about .rich, .pdp__media, .pdp__info, .lead__card, .trust-strip__item, .accordion';
    var els = Array.prototype.slice.call(document.querySelectorAll(selectors));
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    els.forEach(function (el, i) {
      el.classList.add('reveal');
      var d = i % 4;
      if (d) el.classList.add('reveal-delay-' + d);
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0, rootMargin: '80px 0px -30px 0px' });
    els.forEach(function (el) { io.observe(el); });
    // safety net: anything that slipped past the observer (fast scroll / jump) gets revealed
    var revealVisible = function () {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        if (el.classList.contains('is-visible')) return;
        var r = el.getBoundingClientRect();
        if (r.top < vh && r.bottom > 0) { el.classList.add('is-visible'); io.unobserve(el); }
      });
    };
    window.addEventListener('scroll', revealVisible, { passive: true });
  }

  /* ---------- Category tabs ---------- */
  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (wrap) {
      var tabs = wrap.querySelectorAll('[data-tab]');
      var panels = wrap.querySelectorAll('[data-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-tab');
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === target); });
        });
      });
    });
  }

  /* ---------- Accordion ---------- */
  function initAccordion() {
    document.querySelectorAll('.accordion__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.accordion__item');
        var panel = item.querySelector('.accordion__panel');
        var open = item.classList.toggle('is-open');
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : null;
      });
    });
  }

  /* ---------- Product page thumbnails ---------- */
  function initPdpGallery() {
    var main = document.querySelector('[data-pdp-main]');
    if (!main) return;
    document.querySelectorAll('[data-pdp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        if (src) main.src = src;
        document.querySelectorAll('[data-pdp-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---------- Checkout consent gate (cart) ---------- */
  function initCheckoutGate() {
    var gate = document.querySelector('[data-checkout-gate]');
    var btn = document.querySelector('[data-checkout-btn]');
    if (!gate || !btn) return;
    var KEY = 'nl_checkout_consent';
    // qty +/- links reload the page; keep the consent ticked across reloads
    if (sessionStorage.getItem(KEY)) gate.checked = true;
    function sync() {
      btn.disabled = !gate.checked;
      if (gate.checked) sessionStorage.setItem(KEY, '1'); else sessionStorage.removeItem(KEY);
    }
    sync();
    gate.addEventListener('change', sync);
  }

  /* ---------- Contact lead form: goal pills ---------- */
  function initLeadForm() {
    var form = document.querySelector('[data-lead-form]');
    if (!form) return;
    var hidden = form.querySelector('[data-goal-input]');
    form.querySelectorAll('[data-goal]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        form.querySelectorAll('[data-goal]').forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        if (hidden) hidden.value = pill.getAttribute('data-goal');
      });
    });
  }

  /* ---------- Distributor disclaimer popup ---------- */
  function initDisclaimer() {
    var modal = document.querySelector('[data-disclaimer]');
    if (!modal) return;
    var KEY = 'nl_disclaimer_ack';
    if (sessionStorage.getItem(KEY)) return;

    function open() { modal.hidden = false; document.body.style.overflow = 'hidden'; }
    function close() { modal.hidden = true; document.body.style.overflow = ''; sessionStorage.setItem(KEY, '1'); }

    open();
    modal.querySelectorAll('[data-disclaimer-accept], [data-disclaimer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQty() {
    document.querySelectorAll('[data-qty-input]').forEach(function (input) {
      var wrap = input.closest('.qty');
      if (!wrap) return;
      var minus = wrap.querySelector('[data-qty-minus]');
      var plus = wrap.querySelector('[data-qty-plus]');
      if (plus) plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
      if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    });
  }

  /* ---------- PDP variant price + sticky-CTA sync ---------- */
  function initVariantPrice() {
    var select = document.querySelector('#pdp-variant');
    var priceEl = document.querySelector('[data-price] .pdp__price-now');
    if (!select || !priceEl) return;
    var dataEl = document.querySelector('[data-variant-data]');
    var variants = [];
    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) {}
    select.addEventListener('change', function () {
      var v = variants.find(function (x) { return String(x.id) === select.value; });
      if (!v) return;
      priceEl.textContent = formatMoney(v.price);
      var stickyId = document.querySelector('[data-sticky-id]');
      if (stickyId) stickyId.value = v.id;
      var stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
    });
  }

  /* ---------- Cart helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var toastT;
  function showToast(msg) {
    var toast = document.querySelector('.cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cart-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    clearTimeout(toastT);
    toastT = setTimeout(function () { toast.classList.remove('is-visible'); }, 3500);
  }

  function formatMoney(cents) {
    var fmt = window.NL_MONEY_FORMAT || '₪{{amount}}';
    var amount = (cents / 100);
    function withCommas(num, decimals) {
      var parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas(amount, 2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withCommas(amount, 0))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommas(amount, 2))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withCommas(amount, 0));
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  /* ---------- Cart drawer ---------- */
  var Cart = {
    drawer: null, body: null, foot: null, subtotal: null,
    init: function () {
      this.drawer = document.querySelector('[data-cart-drawer]');
      if (!this.drawer) return;
      this.body = this.drawer.querySelector('[data-cart-body]');
      this.foot = this.drawer.querySelector('[data-cart-foot]');
      this.subtotal = this.drawer.querySelector('[data-cart-subtotal]');
      var self = this;
      this.drawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
        el.addEventListener('click', function () { self.close(); });
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });

      // Cart icon: open drawer on click + hover (desktop). Target the cart link
      // specifically (the search icon shares the .header__cart class for styling).
      var icon = document.querySelector('[data-cart-icon]');
      if (icon) {
        icon.addEventListener('click', function (e) { e.preventDefault(); self.open(); });
        if (window.matchMedia('(hover: hover)').matches) {
          var hoverT;
          icon.addEventListener('mouseenter', function () { hoverT = setTimeout(function () { self.open(); }, 220); });
          icon.addEventListener('mouseleave', function () { clearTimeout(hoverT); });
        }
      }
      // Drawer item controls (delegated)
      this.body.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-line-change]');
        if (!btn) return;
        e.preventDefault();
        self.change(btn.getAttribute('data-key'), parseInt(btn.getAttribute('data-qty'), 10));
      });
    },
    open: function () {
      if (!this.drawer) return;
      this.drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () { Cart.drawer.classList.add('is-open'); });
      this.refresh();
    },
    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { Cart.drawer.hidden = true; }, 350);
    },
    refresh: function () {
      var self = this;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); updateCartCount(cart.item_count); });
    },
    render: function (cart) {
      if (!cart || !Array.isArray(cart.items)) {
        // error payload (e.g. stock limit) — re-sync with the server instead of showing "empty"
        if (cart && cart.message) showToast(cart.message);
        this.refresh();
        return;
      }
      if (cart.items.length === 0) {
        this.body.innerHTML = '<div class="cart-drawer__empty">העגלה ריקה כרגע.<br><a href="/pages/products">למעבר לחנות</a></div>';
        this.foot.hidden = true;
        return;
      }
      var html = '';
      cart.items.forEach(function (item) {
        var img = item.image ? '<img src="' + esc(item.image) + '" alt="" width="64">' : '';
        var variant = (item.product_has_only_default_variant ? '' : '<div class="cart-line__variant">' + esc(item.variant_title) + '</div>');
        html +=
          '<div class="cart-line">' +
            '<a href="' + esc(item.url) + '" class="cart-line__media">' + img + '</a>' +
            '<div class="cart-line__info">' +
              '<a href="' + esc(item.url) + '" class="cart-line__title">' + esc(item.product_title) + '</a>' +
              variant +
              '<div class="cart-line__price">' + formatMoney(item.final_line_price) + '</div>' +
            '</div>' +
            '<div class="cart-line__qty">' +
              '<button class="qty__btn" data-line-change data-key="' + esc(item.key) + '" data-qty="' + (item.quantity - 1) + '" aria-label="הפחת">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button class="qty__btn" data-line-change data-key="' + esc(item.key) + '" data-qty="' + (item.quantity + 1) + '" aria-label="הוסף">+</button>' +
            '</div>' +
          '</div>';
      });
      this.body.innerHTML = html;
      this.subtotal.textContent = formatMoney(cart.total_price);
      this.foot.hidden = false;
    },
    change: function (key, qty) {
      var self = this;
      this.body.style.opacity = '.5';
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); if (typeof cart.item_count === 'number') updateCartCount(cart.item_count); })
        .catch(function () { showToast('משהו השתבש, נסו שוב'); self.refresh(); })
        .finally(function () { self.body.style.opacity = ''; });
    }
  };

  function initAddToCart() {
    document.querySelectorAll('form[data-add-to-cart]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        var original = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.innerHTML = 'מוסיף...'; }
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
          .then(function (res) {
            if (!res.ok) {
              showToast(res.json && (res.json.description || res.json.message) || 'לא הצלחנו להוסיף לעגלה, נסו שוב');
              return;
            }
            if (Cart.drawer) { Cart.open(); }
          })
          .catch(function () { showToast('לא הצלחנו להוסיף לעגלה, בדקו את החיבור ונסו שוב'); })
          .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = original; } });
      });
    });
  }

  /* ---------- Product matching quiz ---------- */
  function initQuiz() {
    var quiz = document.querySelector('[data-quiz]');
    if (!quiz) return;

    var waNumber = quiz.getAttribute('data-wa') || '';
    var recs = window.QUIZ_RECS || {};
    var steps = Array.prototype.slice.call(quiz.querySelectorAll('[data-step]'));
    var resultEl = quiz.querySelector('[data-result]');
    var bar = quiz.querySelector('[data-progress]');
    var stepLabel = quiz.querySelector('[data-step-label]');
    var backBtn = quiz.querySelector('[data-back]');
    var total = steps.length;
    var current = 0;
    var answers = [];

    function render() {
      steps.forEach(function (s, i) { s.classList.toggle('is-hidden', i !== current); });
      resultEl.classList.add('is-hidden');
      if (bar) bar.style.width = ((current + 1) / total) * 100 + '%';
      if (stepLabel) stepLabel.textContent = 'שאלה ' + (current + 1) + ' מתוך ' + total;
      if (backBtn) backBtn.disabled = current === 0;
    }

    steps.forEach(function (step, idx) {
      step.querySelectorAll('[data-option]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          step.querySelectorAll('[data-option]').forEach(function (o) { o.classList.remove('is-selected'); });
          opt.classList.add('is-selected');
          answers[idx] = opt.getAttribute('data-option');
          setTimeout(function () {
            if (current < total - 1) { current++; render(); } else { showResult(); }
          }, 300);
        });
      });
    });

    if (backBtn) backBtn.addEventListener('click', function () { if (current > 0) { current--; render(); } });

    function showResult() {
      var fallback = Object.keys(recs)[0];
      var rec = recs[answers[0]] || recs[fallback] || { category: 'התאמה אישית', blurb: '', products: [], url: '/pages/products' };
      steps.forEach(function (s) { s.classList.add('is-hidden'); });
      if (bar) bar.style.width = '100%';
      if (stepLabel) stepLabel.textContent = 'סיימת! הנה ההמלצה שלך';
      if (backBtn) backBtn.disabled = true;

      resultEl.querySelector('[data-result-category]').textContent = rec.category;
      resultEl.querySelector('[data-result-blurb]').textContent = rec.blurb || '';

      var grid = resultEl.querySelector('[data-result-products]');
      grid.innerHTML = '';
      (rec.products || []).forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'product-card';
        a.href = p.url || '#';
        var media = p.image
          ? '<div class="product-card__media"><img src="' + esc(p.image) + '" alt="" loading="lazy"></div>'
          : '<div class="product-card__media"><div class="product-card__placeholder"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M3 7l9-4 9 4-9 4-9-4z"/><path d="M3 7v10l9 4 9-4V7"/></svg></div></div>';
        a.innerHTML = media + '<div class="product-card__body"><span class="product-card__tag">' + esc(rec.category) + '</span><h3 class="product-card__title">' + esc(p.title) + '</h3></div>';
        grid.appendChild(a);
      });

      var labels = ['המטרה', 'רמת פעילות', 'האתגר', 'מה שחשוב לי', 'ליווי אישי'];
      var lines = answers.map(function (a, i) { return labels[i] + ': ' + (a || '-'); });
      var msg = 'היי! עברתי על שאלון ההתאמה באתר 🙂\n' + lines.join('\n') + '\n\nההמלצה שקיבלתי: ' + rec.category + '. אשמח לייעוץ אישי.';
      var waLink = resultEl.querySelector('[data-result-wa]');
      if (waLink && waNumber) waLink.href = 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(msg);
      var browseLink = resultEl.querySelector('[data-result-browse]');
      if (browseLink && rec.url) browseLink.href = rec.url;

      resultEl.classList.remove('is-hidden');
      resultEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    render();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDisclaimer();
    Cart.init();
    initSearch();
    initNav();
    initHeaderScroll();
    initReveal();
    initTabs();
    initAccordion();
    initPdpGallery();
    initLeadForm();
    initCheckoutGate();
    initQty();
    initVariantPrice();
    initAddToCart();
    initQuiz();
  });
})();
